import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import * as _ from 'lodash';
import { FuncoesUteisService } from 'src/app/services/commons/funcoes-uteis.service';
import { ComboMetaAtendimento } from '../../../core/combo-meta-atendimento';
import { MetaAtendimento } from '../../../core/meta-atendimento';
import { MetaObjetivo } from '../../../core/metaObjetivo';
import { MetaObjetivoService } from '../../../services/metaObjetivo/meta-objetivo.service';


@Component({
    selector: 'combo-meta-atendimento',
    templateUrl: './combo-meta-atendimento.component.html',
    styleUrls: ['./combo-meta-atendimento.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm},
        {provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup)}],
})
export class ComboMetaAtendimentoComponent implements OnInit {

    @Input() showDisplayId;
    @Input() obrigatorio;
    @Input() selecionado;
    @Input() desabilitado;
    @Input() metasAtendimento: MetaAtendimento[];
    @Input() idAtividade;

    @Output() valorChange = new EventEmitter();

    dados = [];
    data: any = {};

    constructor(private funcoesUteisService: FuncoesUteisService,
                private metaObjetivoService: MetaObjetivoService) {
    }

    ngOnInit(): void {
        this.data = Date.now();

        setTimeout(() => {
            if (this.metasAtendimento) {
                this.metasAtendimento.forEach(meta => {
                    if (meta.metaObjetivo) {
                        const comboMetaAtendimento = new ComboMetaAtendimento();
                        comboMetaAtendimento.id = meta.metaObjetivo.id;
                        comboMetaAtendimento.descricao = meta.metaObjetivo.codigo + ' - ' + meta.metaObjetivo.descricao;
                        if (this.dados.find(dado => dado.id === comboMetaAtendimento.id) === undefined)
                            this.dados.push(comboMetaAtendimento);
                    }
                });
            } else if (this.idAtividade) {
                this.metaObjetivoService.getComboByIdAtividade(this.idAtividade).subscribe((metasAtendimento: MetaObjetivo[]) => {
                    metasAtendimento.forEach(meta => {
                        const comboMetaAtendimento = new ComboMetaAtendimento();
                        comboMetaAtendimento.id = meta.id;
                        comboMetaAtendimento.descricao = meta.descricao;
                        if (this.dados.find(dado => dado.id === comboMetaAtendimento.id) === undefined)
                            this.dados.push(comboMetaAtendimento);
                    })
                })
            }

            this.preencherComboMetaAtendimento();
            this.dados = this.funcoesUteisService.ordernarArray(this.dados, 'descricao');

        }, 0)

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["selecionado"] && this.selecionado && this.selecionado.id) {
            this.preencherComboMetaAtendimento();
        }
    }

    private preencherComboMetaAtendimento() {
        if (this.selecionado && this.selecionado.id && this.dados.length) {
            this.selecionado = _.find(this.dados, {id: this.selecionado.id});
        }
    }

    onValorChange(registro: any) {
        this.valorChange.emit(registro);
        this.preencherComboMetaAtendimento();
    }

}
